window.addEventListener("load", function () {
  let currentIdx = 0;
  let modalCurrentIdx = 0;
  const track = document.getElementById("slider-track");
  const items = document.querySelectorAll(".slide-item");
  const container = document.getElementById("slider-container");
  const prevBtn = document.getElementById("prevBtn");
  const nextBtn = document.getElementById("nextBtn");
  const modalOverlay = document.getElementById("videoModalOverlay");
  const modalContent = document.getElementById("videoModalContent");
  const videoThumbnail = document.getElementById("videoThumbnail");
  const modalThumbnail = document.getElementById("modalThumbnail");
  const videoPlayer = document.getElementById("videoPlayer");
  const closeModal = document.getElementById("closeVideoModal");
  const closeModalBottom = document.getElementById("closeVideoModalBottom");
  const modalPrevBtn = document.getElementById("modal-prev");
  const modalNextBtn = document.getElementById("modal-next");
  const prevTitle = document.getElementById("prev-title");
  const nextTitle = document.getElementById("next-title");
  const modalTitle = document.getElementById("modalTitle");
  const modalText = document.getElementById("modalText");
  if (!items.length) {
    return;
  }
  let isResizing = false;
  let resizeTimeout;
  let shouldAutoPlayOnOpen = true;
  function alignArrowsToVideo() {
    const activeSlide = items[currentIdx];
    if (!activeSlide) return;
    const videoWrapper = activeSlide.querySelector(".relative.group");
    const prevBtnParent = document.querySelector(".video-slider-prev-button");
    const nextBtnParent = document.querySelector(".video-slider-next-button");
    if (videoWrapper && prevBtnParent && nextBtnParent) {
      const videoHeight = videoWrapper.offsetHeight;
      const topValue = videoHeight / 2 + "px";
      prevBtnParent.style.top = topValue;
      nextBtnParent.style.top = topValue;
    }
  }
  function initializeSliderImmediately() {
    const sliderSection = document.querySelector(".video-series-slider");
    if (!items.length || !track || !container || !sliderSection) return;
    currentIdx = 0;
    track.style.transition = "none";
    const containerWidth = container.offsetWidth;
    const itemWidth = items[0].offsetWidth;
    if (itemWidth && containerWidth) {
      const offset = containerWidth / 2 - itemWidth / 2;
      track.style.transform = `translate3d(${offset}px, 0, 0)`;
    }
    items.forEach((item, i) => {
      if (i === 0) {
        item.classList.replace("opacity-60", "opacity-100");
        item.classList.replace("scale-90", "scale-100");
        const overlay = item.querySelector(".slide-overlay");
        if (overlay) overlay.style.opacity = "0";
      }
    });
    requestAnimationFrame(() => {
      sliderSection.classList.add("is-initialized");
      alignArrowsToVideo();
      setTimeout(() => {
        track.style.transition = "transform 0.5s ease-out";
      }, 50);
    });
  }
  initializeSliderImmediately();
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      track.style.transition = "transform 0.5s ease-out";
      alignArrowsToVideo();
    });
  });

  function getVideoItemData(index) {
    if (index < 0 || index >= items.length) {
      return null;
    }
    const item = items[index];
    if (!item) {
      return null;
    }
    return {
      title: item.dataset.title || "",
      text: item.dataset.text || "",
      videoSrc: item.dataset.videoSrc || "",
      mediaType: item.dataset.mediaType || "",
      youtubeThumb: item.dataset.youtubeThumb || "",
      youtubeId: item.dataset.youtubeId || "",
      vimeoThumb: item.dataset.vimeoThumb || "",
      vimeoId: item.dataset.vimeoId || "",
    };
  }

  function extractYouTubeId(url) {
    try {
      if (!url || typeof url !== "string") return "";
      let cleanUrl = url;
      if (url.includes('src="')) {
        const srcMatch = url.match(/src="([^"]+)"/);
        if (srcMatch && srcMatch[1]) {
          cleanUrl = srcMatch[1];
        }
      }
      const patterns = [
        /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i,
        /embed\/([^"&?\/\s]{11})/i,
        /\/watch\?v=([^"&?\/\s]{11})/i,
        /youtu\.be\/([^"&?\/\s]{11})/i,
      ];
      for (const pattern of patterns) {
        const match = cleanUrl.match(pattern);
        if (match && match[1]) {
          return match[1];
        }
      }
      return "";
    } catch (error) {
      console.error("Error extracting YouTube ID:", error);
      return "";
    }
  }

  function updateModalNavigation() {
    const prevData = getVideoItemData(modalCurrentIdx - 1);
    const nextData = getVideoItemData(modalCurrentIdx + 1);
    const currentData = getVideoItemData(modalCurrentIdx);

    // Previous
    if (prevData) {
      modalPrevBtn.disabled = false;
      prevTitle.textContent = prevData.title || "";
    } else {
      modalPrevBtn.disabled = true;
      prevTitle.textContent = "";
    }

    // Next
    if (nextData) {
      modalNextBtn.disabled = false;
      nextTitle.textContent = nextData.title || "";
    } else {
      modalNextBtn.disabled = true;
      nextTitle.textContent = "";
    }

    // Current
    if (modalTitle || modalText) {
      if (currentData) {
        // Title
        if (currentData.title && currentData.title.trim() !== "") {
          modalTitle.textContent = currentData?.title;
          modalTitle.style.display = "block";
        } else {
          modalTitle.textContent = "";
          modalTitle.style.display = "none";
        }

        // Text
        if (currentData.text && currentData.text.trim() !== "") {
          modalText.textContent = currentData?.text;
          modalText.style.display = "block";
        } else {
          modalText.textContent = "";
          modalText.style.display = "none";
        }
      } else {
        modalTitle.textContent = "";
        modalText.textContent = "";
        modalTitle.style.display = "none";
        modalText.style.display = "none";
      }
    }
  }

  function loadVideoInModal(index, shouldAutoPlay = false) {
    const data = getVideoItemData(index);
    if (!data) return;
    let thumbWrapper = document.getElementById("modalThumbnailWrapper");

    if (!thumbWrapper) {
      thumbWrapper = document.querySelector("#videoThumbnail div:first-child");
    }
    if (!shouldAutoPlay) {
      videoThumbnail.style.opacity = "1";
      videoThumbnail.style.pointerEvents = "auto";
      videoPlayer.style.opacity = "0";
      videoPlayer.style.pointerEvents = "none";
      videoPlayer.innerHTML = "";
      if (data.mediaType === "file") {
        thumbWrapper.innerHTML = `
        <video class="w-full h-full object-contain bg-brand-light-blue object-center pointer-events-none" preload="metadata">
          <source src="${data.videoSrc}#t=0.001" type="video/mp4">
        </video>
      `;
      } else {
        let imgSrc = "";
        if (data.vimeoThumb) {
          imgSrc = data.vimeoThumb;
        } else if (data.youtubeThumb) {
          // Prefer the reliable thumbnail PHP already computed (hqdefault)
          imgSrc = data.youtubeThumb;
        } else if (
          data.mediaType === "url" &&
          (data.youtubeId || data.videoSrc.includes("youtube"))
        ) {
          const youtubeId = data.youtubeId || extractYouTubeId(data.videoSrc);
          if (youtubeId) {
            // hqdefault exists for all videos; maxresdefault often 200s a gray placeholder
            imgSrc = `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;
          }
        }
        thumbWrapper.innerHTML = `
        <img src="${imgSrc}"
             class="w-full h-full object-contain object-center bg-brand-light-blue"
             onerror="this.onerror=null; this.src='https://img.youtube.com/vi/${data.youtubeId || extractYouTubeId(data.videoSrc)}/hqdefault.jpg'">`;
      }
    } else {
      loadAndPlayVideo(data);
    }
    updateModalNavigation();
  }
  function loadAndPlayVideo(data) {
    videoThumbnail.style.opacity = "0";
    videoThumbnail.style.pointerEvents = "none";
    videoPlayer.style.opacity = "1";
    videoPlayer.style.pointerEvents = "auto";
    videoPlayer.innerHTML = "";
    if (data.mediaType === "file") {
      videoPlayer.innerHTML = `
        <video controls autoplay class="w-full h-full object-contain object-center bg-brand-light-blue">
          <source src="${data.videoSrc}" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      `;
    } else {
      let embedUrl = "";
      const youtubeId = data.youtubeId || extractYouTubeId(data.videoSrc);

      if (youtubeId) {
        embedUrl = `https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
      } else if (data.vimeoId) {
        embedUrl = `https://player.vimeo.com/video/${data.vimeoId}?autoplay=1&muted=0&title=0&byline=0&portrait=0`;
      }

      if (embedUrl) {
        videoPlayer.innerHTML = `
    <iframe 
      src="${embedUrl}" 
      class="absolute inset-0 w-full h-full" 
      frameborder="0" 
      allow="autoplay; fullscreen; picture-in-picture" 
      allowfullscreen
      title="YouTube video player">
    </iframe>
  `;
      } else {
        videoPlayer.innerHTML =
          '<div class="text-white p-4 flex items-center justify-center h-full">Could not load video</div>';
      }
    }
  }
  function playVideoFromThumbnail() {
    const data = getVideoItemData(modalCurrentIdx);
    if (!data || !data.videoSrc) {
      console.error("No video data found for playback");
      return;
    }
    loadAndPlayVideo(data);
  }
  function openVideoModal(index) {
    modalCurrentIdx = parseInt(index);
    if (
      isNaN(modalCurrentIdx) ||
      modalCurrentIdx < 0 ||
      modalCurrentIdx >= items.length
    ) {
      console.error("Invalid index:", index);
      return;
    }
    shouldAutoPlayOnOpen = true;
    loadVideoInModal(modalCurrentIdx, true);
    modalOverlay.classList.remove("hidden", "pointer-events-none");
    modalOverlay.style.display = "flex";
    void modalOverlay.offsetWidth;
    setTimeout(() => {
      modalOverlay.classList.add("opacity-100");
      modalContent.classList.remove("scale-95");
      modalContent.classList.add("scale-100");
    }, 10);
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
  }
  function navigateModal(direction) {
    const newIndex = modalCurrentIdx + direction;
    if (newIndex >= 0 && newIndex < items.length) {
      modalCurrentIdx = newIndex;
      loadVideoInModal(newIndex, false);
    }
  }
  function hideVideoModal() {
    if (videoPlayer.innerHTML.includes("iframe")) {
      const iframe = videoPlayer.querySelector("iframe");
      if (iframe) {
        iframe.src = "";
      }
    } else if (videoPlayer.innerHTML.includes("video")) {
      const video = videoPlayer.querySelector("video");
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    }
    videoThumbnail.style.opacity = "1";
    videoThumbnail.style.pointerEvents = "auto";
    videoPlayer.style.opacity = "0";
    videoPlayer.style.pointerEvents = "none";
    videoPlayer.innerHTML = "";
    modalOverlay.classList.remove("opacity-100");
    modalContent.classList.remove("scale-100");
    modalContent.classList.add("scale-95");
    setTimeout(() => {
      modalOverlay.classList.add("hidden", "pointer-events-none");
      modalOverlay.style.display = "none";
    }, 300);
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
  }
  function updateSlider() {
    const containerWidth = container.offsetWidth || container.clientWidth;
    const itemWidth = items[0]?.offsetWidth || items[0]?.clientWidth || 0;
    if (itemWidth > 0 && containerWidth > 0) {
      const offset =
        containerWidth / 2 - itemWidth / 2 - currentIdx * itemWidth;
      track.style.transform = `translateX(${offset}px)`;
    }
    if (!isResizing) {
      if (!items.length) {
        if (prevBtn) prevBtn.style.display = "none";
        if (nextBtn) nextBtn.style.display = "none";
        return;
      }
      if (items.length <= 1) {
        if (prevBtn) prevBtn.style.display = "none";
        if (nextBtn) nextBtn.style.display = "none";
      } else {
        if (prevBtn) prevBtn.style.display = "flex";
        if (nextBtn) nextBtn.style.display = "flex";
      }
      items.forEach((item, i) => {
        const content = item.querySelector(".slide-content");
        const videoWrapper = item.querySelector(".relative.group");
        const newsVideoWrapper = item.querySelector(
          ".relative.group.news-videos",
        );
        const overlay = item.querySelector(".slide-overlay");
        if (i === currentIdx) {
          item.classList.replace("opacity-60", "opacity-100");
          item.classList.replace("scale-90", "scale-100");
          if (overlay) {
            overlay.style.opacity = "0";
          }
          if (content) {
            content.classList.replace("opacity-0", "opacity-100");
            content.classList.remove("pointer-events-none");
          }
          if (videoWrapper) {
            videoWrapper.classList.add(
              "border-[.5rem]",
              "border-brand-light-sky-blue",
            );
          }
          if (newsVideoWrapper) {
            newsVideoWrapper.classList.add(
              "border-[.5rem]",
              "border-brand-warm-beige",
            );
          }
        } else {
          item.classList.replace("opacity-100", "opacity-60");
          item.classList.replace("scale-100", "scale-90");
          if (overlay) {
            overlay.style.opacity = "1";
          }
          if (content) {
            content.classList.replace("opacity-100", "opacity-0");
            content.classList.add("pointer-events-none");
          }
          if (videoWrapper) {
            videoWrapper.classList.remove(
              "border-[8px]",
              "border-brand-light-sky-blue",
            );
          }
          if (newsVideoWrapper) {
            newsVideoWrapper.classList.remove(
              "border-[8px]",
              "border-brand-warm-beige",
            );
          }
        }
      });
      if (prevBtn) prevBtn.disabled = currentIdx === 0;
      if (nextBtn) nextBtn.disabled = currentIdx === items.length - 1;
    }
    alignArrowsToVideo();
  }
  function moveSlider(dir) {
    currentIdx += dir;
    if (currentIdx < 0) currentIdx = 0;
    if (currentIdx >= items.length) currentIdx = items.length - 1;
    updateSlider();
  }
  function handleResize() {
    document.body.classList.add("resizing");
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
    }
    track.style.transition = "none";
    isResizing = true;
    const containerWidth = container.offsetWidth || container.clientWidth;
    const itemWidth = items[0]?.offsetWidth || items[0]?.clientWidth || 0;
    if (itemWidth > 0 && containerWidth > 0) {
      const offset =
        containerWidth / 2 - itemWidth / 2 - currentIdx * itemWidth;
      track.style.transform = `translateX(${offset}px)`;
    }

    resizeTimeout = setTimeout(() => {
      isResizing = false;
      void track.offsetWidth;
      track.style.transition = "transform 0.5s ease-out";
      updateSlider();
      setTimeout(() => {
        document.body.classList.remove("resizing");
      }, 100);
    }, 150);
  }
  resizeTimeout = setTimeout(() => {
    updateSlider();
    alignArrowsToVideo();
  }, 150);
  function initEventListeners() {
    document.querySelectorAll(".video-trigger").forEach((trigger) => {
      trigger.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const index = parseInt(this.getAttribute("data-index"));
        if (!isNaN(index)) {
          openVideoModal(index);
        }
      });
    });
    document.querySelectorAll(".slide-item").forEach((slide) => {
      slide.addEventListener("click", function (e) {
        if (
          !e.target.closest("button") &&
          !e.target.closest(".video-slider-prev-button") &&
          !e.target.closest(".video-slider-next-button")
        ) {
          const index = parseInt(this.getAttribute("data-index"));
          if (!isNaN(index)) {
            openVideoModal(index);
          }
        }
      });
    });
    if (closeModal) {
      closeModal.addEventListener("click", hideVideoModal);
    }
    if (closeModalBottom) {
      closeModalBottom.addEventListener("click", hideVideoModal);
    }
    if (modalOverlay) {
      modalOverlay.addEventListener("click", (e) => {
        if (e.target === modalOverlay) hideVideoModal();
      });
    }
    if (videoThumbnail) {
      videoThumbnail.addEventListener("click", playVideoFromThumbnail);
    }
    if (modalPrevBtn) {
      modalPrevBtn.addEventListener("click", () => navigateModal(-1));
    }
    if (modalNextBtn) {
      modalNextBtn.addEventListener("click", () => navigateModal(1));
    }
    if (prevBtn) prevBtn.addEventListener("click", () => moveSlider(-1));
    if (nextBtn) nextBtn.addEventListener("click", () => moveSlider(1));
    window.addEventListener("resize", handleResize);
    document.addEventListener("keydown", (e) => {
      if (!modalOverlay.classList.contains("hidden")) {
        if (e.key === "Escape") {
          hideVideoModal();
        } else if (e.key === "ArrowLeft") {
          e.preventDefault();
          navigateModal(-1);
        } else if (e.key === "ArrowRight") {
          e.preventDefault();
          navigateModal(1);
        }
      }
    });
  }
  function init() {
    initEventListeners();
    window.openVideoModal = openVideoModal;
    window.moveSlider = moveSlider;
    window.hideVideoModal = hideVideoModal;
  }
  init();
});
